import { render, staticRenderFns } from "./IndependentProvidersAdmin.vue?vue&type=template&id=1d7a3d77&scoped=true&"
import script from "./IndependentProvidersAdmin.vue?vue&type=script&lang=js&"
export * from "./IndependentProvidersAdmin.vue?vue&type=script&lang=js&"
import style0 from "./IndependentProvidersAdmin.vue?vue&type=style&index=0&id=1d7a3d77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7a3d77",
  null
  
)

export default component.exports